const SettingsHeeader = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900">
        Settings
      </h1>

      <p className="mt-2 text-gray-500">
        Manage your account preferences and security.
      </p>
    </div>
  );
};

export default SettingsHeeader;
